import { z } from 'zod';

import { EmployeeRole } from '@/common/graphql';

import { UserEmployee } from '../core/user-employee';

export const EmployeePermissionFormData = z.object({
  role: z.nativeEnum(EmployeeRole).default(EmployeeRole.Basic),
  companyIds: z.array(z.string()).default([]),
  employeeIds: z.array(z.string()).default([]),
  employees: z.array(UserEmployee).default([]),
  isAllEmployees: z.boolean().default(true),
  idpFullAccess: z.boolean().default(false),
});
export type EmployeePermissionFormDataType = z.infer<typeof EmployeePermissionFormData>;
